module.exports = __webpack_public_path__ + "static/img/SMAP.4b0b3a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/SMAP.png
// module id = YSFu
// module chunks = 18